export const moeda = (valor) => {
  const value = (typeof valor === 'undefined' ? 0 : parseFloat(valor));
  // com R$
  const formatar = value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
  return formatar;
};

export const not = () => {};
